import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import {
  LayoutDashboard,
  FileText,
  CheckSquare,
  Calendar as CalendarIcon,
  Users,
  Split,
  BookOpen,
  CreditCard,
  UserCircle,
  LogOut
} from 'lucide-react';
import { supabase } from '../utils/supabase';

const navigation = [
  { name: 'Dashboard', icon: LayoutDashboard, path: '/' },
  { name: 'Summaries', icon: FileText, path: '/summaries' },
  { name: 'Follow-Ups', icon: CheckSquare, path: '/follow-ups' },
  { name: 'Calendar', icon: CalendarIcon, path: '/calendar' },
  { name: 'CRM', icon: Users, path: '/crm' },
  { name: 'My Doubles', icon: Split, path: '/doubles' },
  { name: 'Knowledge Base', icon: BookOpen, path: '/knowledge-base' },
  { name: 'Billing', icon: CreditCard, path: '/billing' },
];

const Sidebar = () => {
  const navigate = useNavigate();

  const handleSignOut = async () => {
    try {
      const { error } = await supabase.auth.signOut();
      if (error) throw error;
      navigate('/signout', { replace: true });
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  return (
    <aside className="fixed left-0 top-0 h-screen w-64 bg-white border-r border-gray-200 flex flex-col">
      {/* Logo section: fills as much as possible within h-20 */}
      <div className="flex items-center justify-center h-20 border-b border-gray-200">
        <img
          src="/logo.png"
          alt="Double Me"
          className="h-full w-auto max-w-[90%] object-contain"
          style={{ display: 'block' }}
        />
      </div>

      <nav className="flex-1 px-4 space-y-1 mt-2">
        {navigation.map((item) => (
          <NavLink
            key={item.name}
            to={item.path}
            className={({ isActive }) =>
              `flex items-center px-4 py-3 text-sm font-medium rounded-lg transition-colors ${
                isActive
                  ? 'bg-primary/10 text-primary shadow-retro border-2 border-dark'
                  : 'text-gray-600 hover:bg-gray-50'
              }`
            }
          >
            <item.icon className="h-5 w-5 mr-3" />
            {item.name}
          </NavLink>
        ))}
      </nav>

      <div className="p-4 border-t border-gray-200">
        <NavLink
          to="profile"
          className={({ isActive }) =>
            `flex items-center px-4 py-3 text-sm font-medium rounded-lg transition-colors ${
              isActive
                ? 'bg-primary/10 text-primary'
                : 'text-gray-600 hover:bg-gray-50'
            }`
          }
        >
          <UserCircle className="h-5 w-5 mr-3" />
          Profile
        </NavLink>
        <button 
          onClick={handleSignOut}
          className="flex items-center px-4 py-3 text-sm font-medium text-gray-600 hover:bg-gray-50 rounded-lg w-full transition-colors"
        >
          <LogOut className="h-5 w-5 mr-3" />
          Sign Out
        </button>
      </div>
    </aside>
  );
};

export default Sidebar;
